export default __webpack_public_path__ + "static/media/tsBW.ddd68529.webp";